module.exports = __webpack_public_path__ + "img/cart-menu-repot.57ac17fd.png";